// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'assets/stylesheets/cssreset-min.css'
import 'assets/stylesheets/flex.css'
import 'element-ui/lib/theme-default/index.css'
import 'assets/stylesheets/element-theme-vipkid-green.styl'
import locale from 'element-ui/lib/locale/lang/en'
require('es6-promise/auto')

import '@badger/fonts/lib/index.css'

import Vue from 'vue'
import App from './App'

import ElementUI from 'element-ui'
import VueRouter from 'vue-router'
import routes from './router-config'
// import cookies from 'cookies-js'

Vue.use(VueRouter)
Vue.use(ElementUI, { locale })

/* eslint-disable no-new */
const router = new VueRouter({
  routes,
  mode: 'history',
  saveScrollPosition: true
})

/* eslint-disable no-new */
new Vue({
  router,
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js